// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateLanguagePrimaryLanguage = (key, list) =>
    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            primaryLanguage: list.find(item => item.key === key),
            type: actions.UPDATE_USER_PREFERENCES_LANGUAGE_PRIMARY_LANGUAGE
        });

    };



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/language-settings.js